import {
  Component,
  NgModule,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  NgbModal,
  NgbPaginationModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { response } from 'express';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { MasterInformationService } from '../../../Services/master-information.service';
import {
  NgbModalModule,
  NgbModalRef,
  NgbTooltip,
} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HttpResponse } from '@angular/common/http';
import { UserManagementService } from '../../../Services/user-management.service';
import { DashboardService } from '../../../Services/dashboard.service';
import * as XLSX from 'xlsx';
import autoTable from 'jspdf-autotable';
import jsPDF from 'jspdf';

type User = {
  id: string;
  name: string;
  type: string;
  date: string;
  userStatus: string;
  city: string;
  zone: string;
  crNumber: string;
  vatNumber: string;
  status: string;
};

@Component({
  selector: 'app-dumpster',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    ToastrModule,
    NgbPaginationModule,
    NgbModalModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
  ],
  templateUrl: './dumpster.component.html',
  styleUrl: './dumpster.component.css',
})
export class DumpsterComponent implements OnInit {
  @ViewChild('changeStatusModal') changeStatusModal!: TemplateRef<any>;
  // Define filter options
  userTypes = ['Corporate Requestor', 'Individual Requestor'];
  cities = ['New York', 'Los Angeles', 'Chicago', 'Chennai'];
  zones = ['North', 'South', 'East', 'West'];

  // ---------------------- Pagination ---------------------- //
  page = 1;
  pageSize = 5;

  // Initial user data
  users: User[] = [
    {
      id: '1',
      name: 'Manoj Enterprises',
      type: 'Corporate Requestor',
      date: '09/12/2024',
      userStatus: 'Accepted',
      city: 'New York',
      zone: 'North',
      crNumber: '1',
      vatNumber: '1',
      status: 'Active',
    },
    {
      id: '2',
      name: 'Raja',
      type: 'Corporate Requestor',
      date: '09/12/2024',
      userStatus: 'Pending',
      city: 'Los Angeles',
      zone: 'South',
      crNumber: '2',
      vatNumber: '2',
      status: 'Inactive',
    },
    {
      id: '3',
      name: 'Arun Prabhakaran',
      type: 'Individual Requestor',
      date: '09/12/2024',
      userStatus: 'Pending',
      city: 'Chennai',
      zone: 'East',
      crNumber: '3',
      vatNumber: '3',
      status: 'Inactive',
    },
    {
      id: '4',
      name: 'Vijay Prabhakaran',
      type: 'Individual Requestor',
      date: '09/12/2024',
      userStatus: 'Rejected',
      city: 'Chicago',
      zone: 'West',
      crNumber: '4',
      vatNumber: '4',
      status: 'Active',
    },
  ];

  cityOptions: string[] = [];
  zoneOptions: string[] = [];
  userStatusOptions: string[] = [];
  statusOptions: string[] = [];
  filters: { [key: string]: string } = {}; // Stores active filters

  // Filtered users based on selections

  // Filter selection values
  selectedUserType = 'all';
  selectedCity = 'all';
  selectedZone = 'all';
  selectedStatus = 'all'; // New filter for Status
  selectedFilterStatus = ''; // Status filter (empty means all)

  // Sort direction state
  sortDirection: { [key: string]: 'asc' | 'desc' } = {
    name: 'asc',
    type: 'asc',
    date: 'asc',
    status: 'asc',
    id: 'asc', // Sorting for Requestor ID
    city: 'asc', // Sorting for City
    zone: 'asc', // Sorting for Zone
  };

  // Modal visibility and form
  selectedUser: User | null = null; // Initialize as null to avoid errors
  isChangeStatusPopupOpen = false;
  currentCityForStatusChange: any = null;
  dumpsterList: any;
  userStatus: any;
  userId: any;
  currentUserForStatusChange: any;
  cityList: any;
  selectedCityId: any;
  zoneList: any;
  filteredUsers: any;
  cityId: any;
  originalTableData: any;

  downloadDocumentsModalRef: any;

  userIdForDownload: string = '';
  allCount: any;
  containerForm: FormGroup;
  containerDetails: any;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private userService: UserManagementService,
    private toastr: ToastrService,
    private masterService: MasterInformationService,
    private dashService: DashboardService,
    private spinner: NgxSpinnerService
  ) {
    this.containerForm = this.fb.group({
      containerType: [{ value: '', disabled: true }],
      capacity: [{ value: '', disabled: true }],
      quantity: [{ value: '', disabled: true }],
    });
  }

  // --------------------------------------- OnInit --------------------------------------- //

  ngOnInit() {
    this.getDumpsterList();
    this.getCity();
    this.cityOptions = Array.from(new Set(this.users.map((user) => user.city)));
    this.zoneOptions = Array.from(new Set(this.users.map((user) => user.zone)));
    this.userStatusOptions = Array.from(
      new Set(this.users.map((user) => user.userStatus))
    );
    this.statusOptions = Array.from(
      new Set(this.users.map((user) => user.status))
    );
  }

  // --------------------------------------- Open Details Modal --------------------------------------- //

  openChangeStatusPopup(user: any): void {
    this.userId = user.userId;
    this.userStatus = user.isActive;
    this.currentUserForStatusChange = { ...user };
    const modalRef = this.modalService.open(this.changeStatusModal, {
      backdrop: 'static',
      centered: true,
    });
  }

  // --------------------------------------- Pagination --------------------------------------- //

  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.filteredUsers?.slice(start, end);
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  // --------------------------------------- Get Dumpster List API --------------------------------------- //

  getDumpsterList() {
    this.userService.getUserList(apiEndPoints.allUsers, 3).subscribe({
      next: (response: any) => {
        this.allCount = response.body.details;
        console.log(this.allCount);
        this.dumpsterList = response.body.details.userList;
        this.filteredUsers = this.dumpsterList;
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  getStatus(status: any): string {
    switch (status) {
      case true:
      case 'true':
      case 1:
        return 'Active';
      case false:
      case 'false':
      case 0:
        return 'Inactive';
      default:
        return 'Unknown'; // Handle cases where the status is unexpected
    }
  }

  // ----------------------------------- Get All City List API ----------------------------------- //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.cityList = response.body.details;
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- Get All Zone List API ----------------------------------- //

  getZone(callback?: () => void) {
    this.dashService.getZoneList(apiEndPoints.zoneList, this.cityId).subscribe({
      next: (response: any) => {
        this.zoneList = response.body.details;
        if (callback) callback();
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- Filter Dropdown ----------------------------------- //

  filterGrid(event: any) {
    const selectedValue = (event.target as HTMLSelectElement).value;
    const filterType = (event.target as HTMLSelectElement).id;

    if (filterType === 'selectCity') {
      this.cityId = selectedValue;
      this.selectedCityId = selectedValue;
      this.selectedZone = 'all'; // Reset zone when city changes
      this.getZone(() => {
        this.applyFilters(); // Apply filters after zone list updates
      });
    } else if (filterType === 'selectZone') {
      this.selectedZone = selectedValue;
      this.applyFilters(); // Apply filters immediately
    } else if (filterType === 'selectStatus') {
      this.selectedStatus = selectedValue;
      this.applyFilters(); // Apply filters immediately
    }
  }

  applyFilters() {
    this.filteredUsers = this.dumpsterList.filter((user: any) => {
      const matchesCity =
        this.selectedCityId === 'all' ||
        user.cityId === Number(this.selectedCityId);
      const matchesZone =
        this.selectedZone === 'all' ||
        user.zoneId === Number(this.selectedZone);
      const matchesStatus =
        this.selectedStatus === 'all' ||
        user.userStatus === this.selectedStatus;

      return matchesCity && matchesZone && matchesStatus;
    });

    // Display "No Data Found" when filteredUsers is empty
    if (this.filteredUsers.length === 0) {
      this.filteredUsers = [];
    }
  }

  applyFilter(filterType: string, value: string) {
    if (filterType === 'city') {
      this.selectedCityId = value;
    } else if (filterType === 'zone') {
      this.selectedZone = value;
    } else if (filterType === 'status') {
      this.selectedStatus = value;
    }
  }

  // ----------------------------- Active & Inactive Users API ----------------------------- //

  changeUserStatus(modal: any) {
    const toggledStatus =
      this.userStatus === true || this.userStatus === 'true' ? false : true;

    this.userService
      .postActiveInactiveUser(
        apiEndPoints.activeInactiveUsers,
        this.userId,
        toggledStatus
      )
      .subscribe({
        next: (response: any) => {
          modal.close();
          this.currentUserForStatusChange.userStatus = toggledStatus;
          this.toastr.success(
            `UserName "${
              this.currentUserForStatusChange.companyName
            }" status changed to ${
              this.currentUserForStatusChange.userStatus ? 'Active' : 'Inactive'
            }`,
            'Status Updated',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
          this.getDumpsterList();
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  sortGrid(column: keyof User | 'id' | 'city' | 'zone' | 'name') {
    const direction = this.sortDirection[column];

    // Sort based on current direction
    this.filteredUsers.sort((a: any, b: any) => {
      if (a[column] > b[column]) {
        return direction === 'asc' ? 1 : -1;
      } else if (a[column] < b[column]) {
        return direction === 'asc' ? -1 : 1;
      }
      return 0;
    });

    // Toggle the sorting direction for the next sort
    this.sortDirection[column] = direction === 'asc' ? 'desc' : 'asc';
  }

  // Handle filter selection for status
  toggleStatusFilter(status: string): void {
    this.selectedStatus = status; // Update selected status filter
    // this.filterGrid();
  }

  // --------------------------------------- Clear filter --------------------------------------- //

  clearFilter() {
    this.getDumpsterList();
    // this.filters = {};
    // this.filteredUsers = [...this.users];
  }

  openDownloadDocumentsModal(userId: any, modal: any) {
    // this.orderIdForDownloadInvoice = orderId;
    this.userIdForDownload = userId;
    this.downloadDocumentsModalRef = this.modalService.open(modal);
  }

  // ------------------------------- Export to Excel ------------------------------- //
  exportToExcel(): void {
    console.log('hii');
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dumpsterList);
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'DumpsterList.xlsx');
  }

  downloadCrVatDocument(type: string) {
    this.downloadDocumentsModalRef.close();
    this.spinner.show();

    this.userService
      .crVatDownload(apiEndPoints.crVatDownload, this.userIdForDownload, type)
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          this.spinner.hide();

          // Extract the filename from Content-Disposition header
          const contentDisposition = response.headers.get(
            'Content-Disposition'
          );
          let filename = this.extractFileName(contentDisposition);

          // Determine file extension based on 'type' or Content-Type
          const contentType = response.headers.get('Content-Type') || '';
          let extension = this.getFileExtension(contentType, type);

          // Fallback if filename is not found
          if (!filename) {
            filename = `user-${
              this.userIdForDownload
            }-${type.toLowerCase()}.${extension}`;
          }

          // Create a Blob URL
          const blob: Blob = response.body as Blob;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');

          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);

          this.toastr.success('File downloaded successfully', 'Success', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        },
        error: (error: any) => {
          this.spinner.hide();
          console.error('Error:', error);
          this.toastr.error(
            'Unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            }
          );
        },
      });
  }

  private extractFileName(contentDisposition: string | null): string | null {
    if (!contentDisposition) return null;

    // Match filename from Content-Disposition header
    const matches = contentDisposition.match(
      /filename\*?=(?:UTF-8'')?["']?([^;"']+)/
    );
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  private getFileExtension(contentType: string, type: string): string {
    const mimeMap: { [key: string]: string } = {
      'application/pdf': 'pdf',
      'image/png': 'png',
      'image/jpeg': 'jpg',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        'xlsx',
      'application/octet-stream': type.toLowerCase() === 'cr' ? 'pdf' : 'jpg', // Fallback for CR or VAT type
    };

    // If contentType is not specified, rely on 'type' (CR or VAT)
    return mimeMap[contentType] || mimeMap['application/octet-stream'];
  }

  openContainerDetails(userId: any, modal: any) {
    console.log(userId);
    this.modalService.open(modal, {
      ariaLabelledBy: 'bank-details-modal-title',
    });

    this.userService
      .getContainerDetails(apiEndPoints.containerDetails, userId)
      .subscribe({
        next: (response: any) => {
          this.containerDetails = response.body.containerDeatils;
          console.log(this.containerDetails);
        },
      });
  }

  // ------------------------------- Print List or Download PDF ------------------------------- //

  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'Dumpster_List.pdf';

    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );

        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );

        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );

          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );

          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'Dumpster List';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });

          // Table headers
          const headers = [
            [
              { content: 'Dumpster Name' },
              { content: 'Mobile No' },
              { content: 'City' },
              { content: 'Zone' },
              { content: 'Date Registered' },
              { content: 'CR Number' },
              { content: 'VAT Number' },
              { content: 'Status' },
            ],
          ];

          let tableBody: any[] = [];
          // Ensure Year is filled for every row
          this.pagedData.forEach((user: any) => {
            const formattedDate = new Date(user.createdDate).toLocaleDateString(
              'en-GB',
              {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              }
            );
            let userStatus = this.getStatus(user.isActive);

            tableBody.push([
              user.companyName,
              user.phNo,
              user.cityName,
              user.zoneName,
              formattedDate,
              user.crNumber,
              user.vatNumber,
              userStatus,
            ]);
          });

          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });

          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
  getZoneNames(user: any): string {
    console.log('adsf')
    if (user.zoneName) {
      return user.zoneName;
    } else if (user.userZoneList_DTOs && user.userZoneList_DTOs.length > 0) {
      return user.userZoneList_DTOs.map((z: any) => z.zoneName).join(', ');
    } else {
      return '';
    }
  }
}
